// VH-228 phase 0: pure helpers for stored cycle documents.

/** The only markup a document may carry — **bold**, *emphasis* — as tokens; never HTML. */
export function parseRichText(text = '') {
  const tokens = []
  let bold = false
  let italic = false
  let buffer = ''
  const flush = () => {
    if (buffer) tokens.push({ text: buffer, bold, italic })
    buffer = ''
  }
  for (let i = 0; i < text.length; i += 1) {
    if (text[i] === '*' && text[i + 1] === '*') {
      flush()
      bold = !bold
      i += 1
    } else if (text[i] === '*' && /\S/.test(text[italic ? i - 1 : i + 1] ?? '')) {
      flush()
      italic = !italic
    } else {
      buffer += text[i]
    }
  }
  flush()
  return tokens
}

/** UI language → the document language requested from the API. */
export const documentLanguage = (language = 'en') =>
  language.startsWith('pt') ? 'pt-BR' : language.startsWith('de') ? 'de' : 'en'
